import { useReportRouteLoading } from '../hooks/use-route-loading';

/**
 * Suspense fallback for lazy section bundles: renders nothing in the page
 * and shows the shell's loading bar under the App Bar instead.
 */
export function RouteLoading() {
  useReportRouteLoading({ loading: true });

  return null;
}
